import React from 'react';

import CreatorEconomyImg from '../../../assets/images/special-offer-creator-economy.png';

import { subscribe_one_path, subscribe_promotion_path } from '../../routes';
import { DEFAULT_ANNUAL_PRICE, SPECIAL_OFFER_PRICE } from '../../utils/backend-api/subscribe';
import { Benefits } from '../shared';

const BENEFITS = [
  'Message and network with the most important people in tech and business',
  'Create a unique profile & search for others in the subscriber directory',
  'Interact & engage in our new discussion forum',
  'Send direct messages to other subscribers',
  'Read in-depth stories you won’t find anywhere else',
];

const SpecialOffer = ({ offerCode }) => {
  return (
    <div id="SpecialOffer">
      <div className="top-section">
        <div className="section-container">
          <div className="offer-description">
            <div className="label">Introducing</div>
            <div className="offer-header">
              The Information Profiles - Connections Worth Your Time
            </div>
            <div className="offer-body">
              Form meaningful connections with the most important people in tech and business with
              The Information Profiles, Directory and Forum. Now free for all subscribers, these new
              tools are designed to make networking worth your time. It&rsquo;s one of the many
              benefits of your subscription, on top of access to our award-winning journalism,
              newsletters, events and more.
            </div>
          </div>
          <div className="offer-details">
            <div className="offer-details-container">
              <div className="subscription">Annual Subscription</div>
              <div className="price">
                ${SPECIAL_OFFER_PRICE}/year{' '}
                <span className="original-price">${DEFAULT_ANNUAL_PRICE}/year</span>
              </div>
              <Benefits benefits={BENEFITS} shrinkTextOnMobile topMargin="Medium" />
              <a
                href={subscribe_promotion_path({ offer: offerCode })}
                className="special-offer-submit-button"
              >
                Subscribe Now
              </a>
            </div>
            <div className="detail-sub-text">
              Get a Corporate Subscription for your team.{' '}
              <a className="contact-link" href="mailto:groups@theinformation.com">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="newsletter-section">
        <div className="section-container">
          <div className="newsletter-description-container">
            <div className="special-offer-header">The Information Forum</div>
            <div className="special-offer-details">
              Share your perspectives, opinions and interests with our audience of tech and finance
              leaders in a discussion forum.
            </div>
            <a
              href={subscribe_promotion_path({ offer: offerCode })}
              className="special-offer-submit-button"
            >
              Subscribe &amp; Get Started
            </a>
          </div>
          <img
            className="banner-img"
            src={CreatorEconomyImg}
            alt="Creator Economy"
            height={300}
            width={300}
          />
        </div>
      </div>
      <div className="bottom-section">
        <div className="label">Subscription Options</div>
        <div className="special-offer-header">Choose a Plan That&rsquo;s Right for You.</div>
        <div className="special-offer-details">
          Join high-powered tech and business leaders who read The Information every day.
        </div>
        <a href={subscribe_one_path()} className="see-plans-button">
          See All Plans
        </a>
      </div>
    </div>
  );
};

export default SpecialOffer;
